import React from 'react';

import {
  ListBase,
} from 'react-admin';

import {
  Dialog,
  DialogTitle,
  Card,
  DialogContent,
} from '@mui/material';

import Pagination from '../layout/Pagination';
import TransactionList from './Transaction';
import { requestTypes } from '../../constants/requestTypes';
import entityTypes, { EntityTypes } from '../../constants/entityTypes';

const DetailedTransactionTable = ({
  open,
  closeDialog,
  from,
  to,
  entityId,
  entityType,
  currency,
  transactionTypeConfiguration,
}: {
  open: boolean;
  closeDialog: () => void;
  from: string;
  to: string;
  entityId: string;
  entityType: EntityTypes;
  currency: string;
  transactionTypeConfiguration?: string;
}) => (
  <Dialog open={open} onClose={closeDialog} fullWidth maxWidth="xl">
    <DialogTitle color="secondary">Detailed transactions</DialogTitle>
    <DialogContent>
      <Card variant="outlined">
        <ListBase
          storeKey={false}
          resource="requests"
          filter={{
            requestType: requestTypes.TRANSACTION,
            'extraInformation.currency': currency,
            'custom.entity': entityId,
            'custom.from': from,
            'custom.to': to,
            'extraInformation.transactionTypes': transactionTypeConfiguration,
            includeRelatedAccounts: entityType === entityTypes.BUSINESS
              || entityType === entityTypes.INDIVIDUAL,
          }}
          perPage={10}
          sort={{ field: 'extraInformation.date', order: 'DESC' }}
        >
          <TransactionList />
          <Pagination disableEmptyText rowsPerPageOptions={[5, 10, 25]} />
        </ListBase>
      </Card>
    </DialogContent>
  </Dialog>
);

export default DetailedTransactionTable;
